import { monteurApi } from '../common/monteur-api';
export var usersApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: ['User']
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getPaginatedUsers: builder.query({
            query: function (query) { return ({
                url: 'User/get-paginated',
                method: 'POST',
                body: query
            }); },
            providesTags: ['Users']
        }),
        createUser: builder.mutation({
            query: function (user) { return ({
                url: 'User/create',
                method: 'POST',
                body: user
            }); },
            invalidatesTags: ['Users', 'Roles']
        }),
        getUser: builder.query({
            keepUnusedDataFor: 0,
            query: function (userId) { return ({
                url: "User/get-by-id?id=".concat(userId),
                method: 'GET'
            }); },
            providesTags: ['User']
        }),
        getUserWithRoles: builder.query({
            keepUnusedDataFor: 0,
            query: function (userId) { return ({
                url: "User/get-with-roles?id=".concat(userId),
                method: 'GET'
            }); },
            providesTags: ['User']
        }),
        updateUser: builder.mutation({
            query: function (user) { return ({
                url: 'User/update',
                method: 'POST',
                body: user
            }); },
            invalidatesTags: ['Users', 'User', 'Roles']
        }),
        updateUserStatus: builder.mutation({
            query: function (command) { return ({
                url: 'User/update-status',
                method: 'POST',
                body: command
            }); },
            invalidatesTags: ['Users', 'User', 'Roles']
        }),
        updateMultipleUsersStatus: builder.mutation({
            query: function (command) { return ({
                url: 'User/update-multiple-status',
                method: 'POST',
                body: command
            }); },
            invalidatesTags: ['Users', 'User', 'Roles']
        })
    }); }
});
export var useGetPaginatedUsersQuery = usersApi.useGetPaginatedUsersQuery, useCreateUserMutation = usersApi.useCreateUserMutation, useLazyGetUserQuery = usersApi.useLazyGetUserQuery, useUpdateUserMutation = usersApi.useUpdateUserMutation, useUpdateUserStatusMutation = usersApi.useUpdateUserStatusMutation, useUpdateMultipleUsersStatusMutation = usersApi.useUpdateMultipleUsersStatusMutation, useLazyGetUserWithRolesQuery = usersApi.useLazyGetUserWithRolesQuery;
